import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import {
  PERMISSIONS,
  hasConfigurationAccess,
} from "../constants/permissions";

interface RequirePermissionProps {
  permission: string | string[];
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  children,
}) => {
  const { hasPermission, userPermissions } = usePermissions();

  // CONFIGURATION_VIEW is a proxy (configuration.view_thumbnail) for "can
  // access the Configurations section" — accept a view grant on any
  // configuration model, not just the specific Thumbnail one.
  const checkOne = (p: string) =>
    p === PERMISSIONS.CONFIGURATION_VIEW
      ? hasConfigurationAccess(userPermissions)
      : hasPermission(p);

  const allowed = Array.isArray(permission)
    ? permission.some(checkOne)
    : checkOne(permission);

  if (!allowed) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
